import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import  BootstrapTable   from 'react-bootstrap-table-next';
//import { Solicitud_actividad } from './expand/Solicitud_actividad';
//import { Solicitud_materia } from './expand/Solicitud_materia';
import 'bootstrap/dist/css/bootstrap.min.css';
//import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
//import {Col, Row, Container } from 'react-bootstrap';
//import crear from './../img/svg/Nueva.svg';
//import enviar from './../img/svg/Enviar(blanco).svg';
 

const API_URL = process.env.REACT_APP_API_URL;

//Funcion para colocar color a las headers la tabla
function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
} function color_head_desc(tipo) {
    if (tipo === 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize:11,
            width: '50%'
        };
    } else if (tipo === 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo === 'id')  {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '15%'
        };
    }else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) { 
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

function estaConformeFormatter(column, colIndex, { sortElement, filterElement }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '60px' }}>
            { filterElement}
            { column.text}
            { sortElement}
        </div>
    );

}
 
function PaoFormatter(cell, row) {
    switch (row.termino) {
        case "1ER TERMINO":
            return (
                <span>PAO-1</span>
            );
            break;
        case "2DO TERMINO":
            return (
                <span>PAO-2</span>
            );
            break;
        case "3ER TERMINO":
            return (
                <span>PAE</span>
            );
            break;
        default: 
            return (
                <span>{cell}</span>
            );
            break;
    } 
}

function desgloseHoras(termino, periodicidad, numhoras, totalhoras) {
    if (periodicidad !== "ANUAL") {
        if (termino === "1") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 20;

        } else if (termino === "2") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 20;

        } else if (termino === "0") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 8;
        }
    } else {
        return totalhoras;
    }
}

export class Docencia_Grado_out extends Component {
    static displayName = Docencia_Grado_out.name;
    static totalmat = 0;
    static totalact = 0;

    handleBtnClick = () => {
        if (!this.state.expanded.includes(0)) {
            this.setState(() => ({
                expanded: [...this.state.expanded, 0]
            })); 
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== 0)
            }));
             
        }
    }

    handleOnExpand = (row, isExpand, rowIndex, e) => {
        if (isExpand) { 
            this.setState(() => ({
                expanded: [...this.state.expanded, row.id]
            }));
        } else { 
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== row.id)
            }));
        }
    }
     

    handleBtnClick_mat = () => {
        if (!this.state.expanded_mat.includes(0)) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, 0]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand_mat = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== row.id)
            }));
        }
    }

    constructor(props) {
        super(props);
        this.state = { 
            actividades: [], solicitudes: [], busqueda: "", solicitudes: [], actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            },
            fila: [],
            fila_mat: [],
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ],materias: [], materia: {
                idcurso: 0, porc: 0, anio: "", term: "", termino: "", codigomateria: "", nommateria: "", numhorasteoricas: 0, numhoraspracticas: 0, paralelo: 0, idtipoactividad: 0,
                observacion: "", fechaInicio: "", fechaFin: "", valorevaluacion: 0, valornumexam: 0, estadocheck: "", tipoprofesor: ""
            }, loading: false, loading2: false, loading3: false, expanded: [], expanded_mat: [], total: 0,
            materia_elegida: [{ idcurso: 0, validada: "", estado_actividad: "" }],
            anio: props.anio, idpersona: props.idprof, actividades_combo: [], periodo: "", newactividad: "", observacion: "",
            nuevoregistro: [], selectact: "", selectidact: "",abierto:false
        };
            
        this.onChangePao = this.onChangePao.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleNew = this.handleNew.bind(this);

        this.updatestate = this.updatestate.bind(this);
        this.updatestate_mat = this.updatestate_mat.bind(this);
    }


    componentDidMount() { 
        if (this.state.anio > 0) {
            //console.log("componentDidMount - cargaAct: ", this.props.cargaAct);
            //console.log("componentDidMount - cargaMat: ", this.props.cargaMat);
            this.populateActividadesData(this.props.idprof,this.props.anio);
            this.populateMateriasData(this.props.idprof, this.props.anio);
            //this.populateActividadesCombo(this.props.idprof, this.props.anio);
        }

    }


    get_radios(termino1, termino2, termino3, anio) {
        //var respu;
        if (termino2 === "2" && termino1 === "1" && termino3 === "0") {
            return (
                'PAE-' + anio + '\n  PAO-' + anio + '-1\n PAO-' + anio + '-2'
            )
        }
        else if (termino1 === "1") {
            if (termino1 === "1" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-1 \nPAE-' + anio
                );
            } else if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1 \nPAO-' + anio + '-2'
                );

            } else {
                return (
                    'PAO-' + anio + '-1'
                );
            }
        } else if (termino2 === "2") {
            if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1\n PAO-' + anio + '-2'
                );

            } else if (termino2 === "2" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-2\n PAE-' + anio
                );
            }
            return (
                'PAO-' + anio + '-2'
            );
        } else if (termino3 === "0") {
            if (termino3 === "0" && termino1 === "1") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-1'
                );

            } else if (termino3 === "0" && termino2 === "2") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-2'
                );
            }
            return (
                'PAE-' + anio
            );
        }
    }
    updatestate(idactividad, descripcion, totalhoras, anio, termino, tipoactividad, observacion, pao1, pao2, pae, accion) {
        //const terminos = this.get_radios(pao1, pao2, pae, anio)
        var solicitudes = this.state.solicitudes

        if (solicitudes.length === 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad !== idactividad)
        }
       
        solicitudes.push({ idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: termino, tipoactividad: tipoactividad, pao1: pao1, pao2: pao2, pae: pae, accion: accion })

        this.setState({ solicitudes: solicitudes });

        this.props.update({ ambito: 'A|R', idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: termino, tipoactividad: 'A|R', pao1: pao1, pao2: pao2, pae: pae, accion: accion });
               
    }

    updatestate_mat(idcurso, descripcion, observacion, anio, termino,totalhoras, accion) {
        var solicitudes = this.state.solicitudes
        if (solicitudes.length === 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad !== idcurso)
        }

        solicitudes.push({
            idactividad: idcurso, descripcion: descripcion,  observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino,totalhoras:totalhoras,termino:termino, accion: accion
        })
        this.setState({ solicitudes: solicitudes });

        this.props.update({ ambito: 'M|R', idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, tipoactividad: 'M|R', totalhoras: totalhoras, termino: termino, accion: accion});

    }
    /////FUNCIONES para interactuar con los si/no de ACtividades
    handleHideClick = (idactividad) => { 
            let obj = this.state.fila.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila[i].validacion = 'si'
                    return this.state.fila[i];
                }
            });
            if (obj == null) {
                this.state.fila.push({
                    idactividad: idactividad,
                    validacion: 'si'
                })
            }
            if (this.state.expanded.includes(idactividad)) {
                this.setState(() => ({
                    expanded: this.state.expanded.filter(x => x !== idactividad)
                }));
            }
            //console.log(this.state.fila); 
       
    }

    handleShowClick = (idactividad) => {

       
            //console.log(idactividad)
            if (!this.state.expanded.includes(idactividad)) {

                let obj = this.state.fila.find((o, i) => {
                    if (o.idactividad === idactividad) {
                        this.state.fila[i].validacion = 'no'
                        return this.state.fila[i];
                    }
                });
                if (obj == null) {
                    this.state.fila.push({
                        idactividad: idactividad,
                        validacion: 'no'
                    })
                }
                this.setState(() => ({
                    expanded: [...this.state.expanded, idactividad]
                }));
            }
            //console.log(this.state.fila); 
    }

    handleHideAllClick = () => {

        let filas = [];

        this.state.actividades.forEach((element) => {
            filas.push({
                idactividad: element.idactividad,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded: [],
            fila: filas
        }));
        //console.log(this.state.fila);
        this.handleAllCheck()
    }

    handleShowAllClick = () => {

        let filas = [];
        let expandir = [];
        this.state.actividades.forEach((element) => {
            filas.push({
                idactividad: element.idactividad,
                validacion: 'no'
            });
            if (!this.state.expanded.includes(element.idactividad)) {
                expandir.push(element.idactividad);
            }
        })
        this.setState(() => ({
            expanded: this.state.expanded.concat(expandir),
            fila: filas
        }));
        //console.log(this.state.fila);
        //console.log(this.state.actividades);
        this.handleAllCheck()
    }

    handleAllCheck() {
        //console.log(this.state.fila);
        const check = document.getElementsByName("all_ag");
        const checkSin = document.getElementById("Actividades_ag").getElementsByClassName('form-check-input');
        //console.log(check);
        //console.log(checkSin);
        if (check[0].checked) {
            //console.log('Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "1") {
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        } else {

            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "0") {
                    //console.log('Nou');
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        }
    }

    /////FUNCIONES para interactuar con los si/no de Materias
    handleHideClick_mat = (idactividad) => {
        let obj = this.state.fila_mat.find((o, i) => {
            if (o.idactividad === idactividad) {
                this.state.fila_mat[i].validacion = 'si'
                return this.state.fila_mat[i];
            }
        });
        if (obj == null) {
            this.state.fila_mat.push({
                idactividad: idactividad,
                validacion: 'si'
            })
        }
        if (this.state.expanded_mat.includes(idactividad)) {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== idactividad)
            }));
        }
        //console.log('MATERIA:' +this.state.fila_mat);

    }

    handleShowClick_mat = (idactividad) => {


        //console.log('MATERIA:' +idactividad)
        if (!this.state.expanded_mat.includes(idactividad)) {

            let obj = this.state.fila_mat.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila_mat[i].validacion = 'no'
                    return this.state.fila_mat[i];
                }
            });
            if (obj == null) {
                this.state.fila_mat.push({
                    idactividad: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, idactividad]
            }));
        }
        //console.log(this.state.fila_mat);
    }

    handleHideAllClick_mat = () => {

        let filas = [];

        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idcurso,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded_mat: [],
            fila_mat: filas
        }));
        //console.log(this.state.expanded_mat);
        this.handleAllCheck_mat()
    }

    handleShowAllClick_mat = () => {

        let filas = [];
        let expandir = [];
        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idcurso,
                validacion: 'no'
            });
            if (!this.state.expanded_mat.includes(element.idcurso)) {
                expandir.push(element.idcurso);
            }
        })
        this.setState(() => ({
            expanded_mat: this.state.expanded_mat.concat(expandir),
            fila_mat: filas
        }));
        //console.log('MATERIA:'+this.state.fila_mat);
        //console.log('MATERIA:' +this.state.materias);
        this.handleAllCheck_mat()
    }

    handleAllCheck_mat() {
        //console.log('MATERIA:' +this.state.fila_mat);
        const check = document.getElementsByName("all_mg");
        const checkSin = document.getElementById("Materias_mg").getElementsByClassName('form-check-input');
        //console.log('MATERIA:' +check);
        //console.log('MATERIA:' +checkSin);
        if (check[0].checked) {
            //console.log('MATERIA:' +'Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "1") {
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        } else {

            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "0") {
                    //console.log('Nou');
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        }
    }

    renderActividadesTable(actividades) {
        //console.log("actividades docencia_grado: ", actividades);
        var actividades_split = [];

        actividades.map((act, index) => {
            if (act.termino3 === "0") {
                //var thoras3 = desgloseHoras(act.termino3, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '0',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": null,
                    "termino2": null,
                    "termino3": act.termino3,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino3
                });
            }

            if (act.termino1 === "1") {
                //var thoras1 = desgloseHoras(act.termino1, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '1',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": act.termino1,
                    "termino2": null,
                    "termino3": null,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino1
                });
            }

            if (act.termino2 === "2") {
                //var thoras2 = desgloseHoras(act.termino2, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '2',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": null,
                    "termino2": act.termino2,
                    "termino3": null,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino2
                });
            }
        });

        var totalactividades = this.state.actividades ? this.state.actividades.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
         
        const columns_acti = [
            {
                dataField: 'id',
                text: '#',
                footer: '',

                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                //footer: '',
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    )
                }
            },
            {
                dataField: 'idactividad',
                text: '#',
                hidden: true,
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'idUnico',
                text: 'ID UNICO',
                hidden: true
            }, {
                dataField: 'actividad',
                text: 'Actividad',
                headerStyle: color_head_desc('d'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'descripcion',
                text: 'Descripción',
                headerStyle: color_head_desc('a'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            },
            {
                dataField: 'termino',
                text: 'Periodo',
                formatter: (cellContent, row) => {
                    if (row.termino1 === "1") {
                        return <>PAO {row.anio}-1</>

                    } else if (row.termino2 === "2") {
                        return <>PAO {row.anio}-2</>

                    } else if (row.termino3 === "0") {
                        return <>PAE {row.anio}</>
                    }
                },
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: 'Subtotal: '
            },
            {
                dataField: 'totalhoras',
                text: 'Horas',
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footerAlign: 'left',
                footer: () => {
                    return (<>{totalactividades.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
                }
                //footer: columnData => {
                //    const total2 = columnData.reduce((acc, item) => (Number(acc) + Number(item)).toFixed(2), 0);
                //    return (<>{total2} horas</>);
                //},
            }, {
                dataField: 'tipoactividad',
                text: 'tipoactividad',
                hidden: true
            }
        ];

        return (
            <>
                { actividades && actividades.length > 0 ?
                    <BootstrapTable
                        id="Actividades_ag"
                        keyField='idUnico'
                        data={actividades_split}
                        columns={columns_acti}
                        bordered={false} 
                    /> : null
                }
            </>
           
        );
    }

    renderMateriasTable(materias) { 

        const columns_materias = [{
            dataField: 'id',
            text: '#',
            footer: '',

            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: '',
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1}
                    </div>
                )
            }
        },{
            dataField: 'codigoMateria',
            text: 'Código',
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'nomMateria',
            text: 'Asignatura',
            headerStyle: color_head_desc('a'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'paralelo',
            text: 'Paralelo',
            headerStyle: color_head_desc('id'), 
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'termino',
            text: 'Periodo',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: PaoFormatter,
            footer: 'Subtotal: '
        }, {
            dataField: 'totalHoras',
            text: 'Horas',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footerAlign: 'left',
            footer: columnData2 => {
                const total1 = columnData2.reduce((acc2, item2) => (Number(acc2) + Number(item2)).toFixed(2), 0);
                return (<> {total1.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
            },
        }];
         

        return (
            <BootstrapTable
                id='Materias_mg'
                keyField='idcurso'
                data={materias}
                columns={columns_materias}
                bordered={false} 
                />  
        );
         
    }
    
    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    
    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    handleChange(e) {
        var idactividad = e.target.value;
        var data = this.state.actividades_combo.filter(x => x.idactividad === idactividad).map(act => act.descripcion);
         
        this.setState({ selectact: data, selectidact: e.target.value  });
    }

    handleSearch(event) {
        this.setState({ observacion: event.target.value });
        //console.log(this.state.observacion);
    }
     

    onChangePao(event) {
        this.setState({
            periodo: event.target.value
        })
        //console.log(this.state.periodo)
    }

    abrirModal = () => {
        this.setState({ abierto: !this.state.abierto });
    }

    cerrarModal = () => {
        this.setState({ abierto: false });
    }

    handleNew(e) {
        var termino = this.state.periodo
        this.updatestate(this.state.selectidact, this.state.selectact, '', this.props.anio, this.state.periodo, 'D', this.state.observacion, termino, termino, termino, 'Nueva Carga')

        //console.log('NUEVOOO' + this.state.selectidact+ this.state.selectact+ ''+ this.props.anio+ this.state.periodo+ 'D'+ this.state.observacion+ termino+ termino+ termino+ 'Nueva Carga')
        this.cerrarModal()
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...this.populateActividadesData(this.props.anio);</em></p>
            : this.renderActividadesTable(this.state.actividades);
        let contents_mat = this.state.loading2
            ? <p><em>Loading... this.populateMateriasData(this.props.anio);</em></p>
            : this.renderMateriasTable(this.state.materias);
        
        const totalmaterias = this.state.materias ? this.state.materias.map(horastot => horastot.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const totalactividades = this.state.actividades ? this.state.actividades.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambitout = totalactividades + totalmaterias;
        //const talambito = this.formatter(talambitout);
        const talambito = talambitout.toLocaleString('en', { maximumFractionDigits: 2 });

        const combo = {
            width: '150px',
        };
        const buttonToLink = {
            fontSize: '0.65em',
            textAlign: 'left',
            float: 'right',
            color: '#58A7E0',
            background: 'none',
            margin: 0,
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            ":hover": {
                color: "yellow"
            }
        }; 
        const estilo = {
            color: 'white',
            fontSize: '15px',
            marginBottom: '20px',
            fontFamily: 'Robota'
        };

        const form_nuevo = {
            fontSize: '0.65em',
            color: "darkgray"
        };

        return (
            <div> 

                {contents_mat}

                {contents} 

                <div className="inline-grid  grid-cols-1 bg-total">
                    <div className="px-1">Total de Ámbito de Docencia Grado: {talambito} horas</div>
                </div>

            </div>
        );
    }

    async populateActividadesData(idpersona,anio) {

        //const response = await fetch(API_URL + 'TblActividades/'+idpersona+'/' +anio+'/R/D');
        //const respuesta = await response.json();
        //console.log("this.props.cargaAct: ", this.props.cargaAct);
        const respuesta = this.props.cargaAct;
        const data = respuesta.filter(x => x.nivelEstudio === 'R');
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idactividad: act.idactividad, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'AR', idactividad: act.idactividad, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino1 + '|' + act.termino2 + '|' + act.termino3 }) })
            data.map(act => { actividades.push({ ambito: 'A|R', idactividad: act.idactividad }) })
            var actividades2 = [];
            data.map(act => { actividades2.push({ tipo: 'A|R', idactividad: act.idactividad, anio: act.anio, descripcion: act.descripcion, periodo: act.termino1 + '|' + act.termino2 + '|' + act.termino3, accion: '', observacion: '', totalhoras: act.totalhoras,  validado: 1 }) })
            this.props.updateCarga(actividades, actividades2);

            
        }
        
        this.setState({ actividad_elegida: selected, actividades: data, loading: false });

    }


    async populateMateriasData(idpersona,anio) {
        //const response = await fetch(API_URL + 'TblMaterias/' + idpersona +'/' + anio);
        //const respuesta = await response.json();
        const respuesta = this.props.cargaMat;
        const data = respuesta;
        this.setState({ materias: data, loading2: false });
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idcurso: act.idCurso, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'MR', idactividad: act.idcurso, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino}) })
            data.map(act => { actividades.push({ ambito: 'M|R', idactividad: act.idCurso }) })
            var actividades2 = [];
            data.map(act2 => { actividades2.push({ tipo: 'M|R', idactividad: act2.idCurso, anio: act2.anio, descripcion: act2.nomMateria, periodo: act2.termino, accion: '', observacion: '', totalhoras: act2.totalHoras, validado: 1 }) })
            this.props.updateCarga(actividades, actividades2);
        }
        
        this.setState({ materia_elegida: selected, materias: data, loading: false });
    }



    async populateActividadesCombo(idpersona, anio) {
        const response = await fetch(API_URL + 'TblActividades/' + anio + '/R/token');
        const respuesta = await response.json();
        const data = respuesta; 
        this.setState({ actividades_combo: data, loading: false });
    }


}
